<template>
    <div class="">
        <b-button class="btn-collapse-tips" size="lg" variant="outline-warning" @click="showCollapse = !showCollapse">{{ $t('menu.instructions') }}</b-button>

        <div class="collapse-tips-area">
            <b-collapse id="map-control-tips" :visible="defaultOpen" v-model="showCollapse">
                <b-card>
                    <b-row>
                        <b-col md="6"><b-img :src="$config.getAssetsURL('img/instr/tooltip_chart01.PNG')" fluid alt="" /></b-col>
                        <b-col md="6"><b-img :src="$config.getAssetsURL('img/instr/tooltip_chart02.PNG')" fluid alt="" /></b-col>
                        <b-col md="6"><b-img :src="$config.getAssetsURL('img/instr/tooltip_chart03.PNG')" fluid alt="" /></b-col>
                        <b-col md="6">
                            <div>
                                <h4>【 {{ $t('menu.instructions') }} 】</h4>
                                <div># 1. {{ $t('tooltip.show_data_toggle') }}</div>
                                <div># 2. {{ $t('tooltip.zoom_data_slider') }}</div>
                                <div># 3. {{ $t('tooltip.min_value_of_the_first_data') }}</div>
                                <div># 4. {{ $t('tooltip.max_value_of_the_first_data') }}</div>
                                <div># 5. {{ $t('tooltip.hover_xaxis_show_tooltip') }}</div>
                                <div># 6. {{ $t('tooltip.yaxis_bounding_of_the_first_data') }}</div>
                                <div># 7. {{ $t('tooltip.yaxis_bounding_of_all_data') }}</div>
                            </div>
                        </b-col>
                    </b-row>
                    
                    <div class="text-center">
                        <b-button variant="warning" @click="showCollapse = false">{{ $t('menu.close') }} {{ $t('menu.instructions') }}</b-button>
                    </div>
                    
                </b-card>
            </b-collapse>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        defaultOpen: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            showCollapse: false,
        }
    },
    mounted () {
        this. showCollapse = this.defaultOpen
    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>

.collapse-tips-area
{
    margin: 5px 15px;
    .card
    {
        border-color: #F0C851;
        background-color: #f8f2e0;
    }
    .card-text
    {
        margin-right: 45px;
    }
    .img-fluid
    {
        margin: 5px;
        border: 2px solid white;
        background-color: white;
        border-radius: 5px !important;
    }
}

</style>
